import React from 'react'
import PropTypes from 'prop-types'

import SignInUserPage from './components/signin/SignInUserPage';
import SignUpUserPage from './components/signup/SignUpUserPage';
import FluxAuthenticationActions from '../actions/FluxAuthenticationActions';
import CurrentUserStore from '../stores/CurrentUserStore';
import BrowserLocationHelper from '../utils/browser_location_helper';

import registerUserSessionToIntercom from '../utils/Intercom/registerUserSessionToIntercom'
import { intercomSendData, intercomTrackEvent } from '../utils/Intercom/intercomHelper';

export default class UserSessionForm extends React.Component {

    static propTypes = {
        redirectURL: PropTypes.string,
    };

    state = {
        showSignIn: this.props.showSignIn || false,
        currentUser: null
    };

    componentDidMount() {
        CurrentUserStore.addChangeListener(this._onCurrentUserChange);
    }

    componentWillUnmount() {
        CurrentUserStore.removeChangeListener(this._onCurrentUserChange);
    }

    _onCurrentUserChange = () => {
        const newUser = CurrentUserStore.getUser();

        if (this.state.currentUser !== newUser) {
            this.setState({
                currentUser: newUser
            });

            if (this.props.redirectURL) {
                BrowserLocationHelper.ChangeURL(this.props.redirectURL);
            }
        }
    };

    onLogin = (user) => {
        FluxAuthenticationActions.logged(user);
        registerUserSessionToIntercom(user)

        intercomTrackEvent("Signin", {})
        intercomSendData({
          "TLT - Last Signin at": Date.now()
        })
    };

    signUpButtonClicked = () => {
        this.setState({showSignIn: false});
    };

    signInButtonClicked = () => {
        this.setState({showSignIn: true});
    };

    renderWelcomeUser() {
        return (
            <div className="text-center">
                <div>
                    <h2>Bentornato {this.state.currentUser.first_name}</h2>
                </div>

                <a href="/">Torna alla home</a>
            </div>
        )
    }

    isFacebookConnectEnabled() {
        return true;
    }

    renderForms() {
        if (this.state.showSignIn) {
            return <SignInUserPage onLogin={this.onLogin}
                                   signUpButtonClicked={this.signUpButtonClicked}
                                   facebookConnectEnabled={this.isFacebookConnectEnabled()}/>
        } else {
            return <SignUpUserPage onLogin={this.onLogin}
                                   signInButtonClicked={this.signInButtonClicked}
                                   facebookConnectEnabled={this.isFacebookConnectEnabled()}
                                   inviter_referral_code={this.props.inviter_referral_code}/>
        }
    }

    render() {
        return this.state.currentUser ? this.renderWelcomeUser() : this.renderForms();
    }
}
